export default function formatPostalCode(postalCode) {
  if (!postalCode || postalCode.length !== 8) {
    throw new Error(`Invalid postalcode: ${postalCode}`);
  }

  return `${postalCode.substring(0, 5)}-${postalCode.substring(5)}`;
}
